import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData, statusTypesData } from "@/data";
import { editClientRevenueReportsTemplateMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditClientRevenueReportTemplate = (setDisabled) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [editClientReportRevenueTemplateAction, { loading }] = useMutation(editClientRevenueReportsTemplateMutation);

    const editClientReportRevenueTemplate = async (data, id) => {
        try {
            await editClientReportRevenueTemplateAction({
                onCompleted: () => {
                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", { entity: t("labels.template") }),
                            statusTypesData.success,
                        ),
                    );

                    setDisabled(true);
                },
                variables: {
                    data: { templateObj: data },
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editClientReportRevenueTemplate,
        loading,
    };
};

export default useEditClientRevenueReportTemplate;
